import React from "react";
import GrComponentFactory from "./gr_component_factory";
import { map } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "SelectMenu",

  propTypes: {
    items: React.PropTypes.arrayOf(
      React.PropTypes.shape({
        name: React.PropTypes.string.isRequired,
        url: React.PropTypes.string,
      })
    ).isRequired,

    defaultIndex: React.PropTypes.number,
  },

  getDefaultProps() {
    return { defaultIndex: 0 };
  },

  onOptionChange(event) {
    const index = event.target.selectedIndex;
    if (this.props.items[index] != null) {
      window.location.href = this.props.items[index].url;
    }
  },

  render() {
    return <select className="gr-dropdown gr-selectMenu u-fullWidth"
      onChange={this.onOptionChange}
      defaultValue={this.props.items[this.props.defaultIndex].name}>
      {map(this.props.items, (option, index) => (<option key={index} value={option.name} disabled={(option.url == null)}>{option.name}</option>))}
    </select>;
  },
});